import styled from 'styled-components'
import STYLE_CONSTANTS from '~/style/constants'

const Description = styled.div`
  color: ${STYLE_CONSTANTS.colors.text.subtleGray};
  font-size: ${props => props.big ? '1rem' : '0.875rem'};
  line-height: 1.1875rem;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  max-width: 250px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`

export default Description
